<script>
import CloseBox from "vue-material-design-icons/CloseBox.vue";
// @group Dialog
// Modal window template
export default {
  name: "Modal",
  components: {
    CloseBox
  },
  props: {
    // Visible flag
    visible: Boolean,
    // Window title
    title: {
      type: String,
      default: "Modal"
    },
    // To show `Close` option
    canClose: Boolean,
    // To show `Ok` option
    showOk: Boolean
  },
  methods: {
    // @vuese
    // Used to hide window
    close() {
      // ...
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    }
  }
};
</script>
<template>
  <transition name="modal-fade" @after-leave="$emit('closed')">
    <div v-show="visible" class="modal-backdrop" @mousedown="close">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        @mousedown.stop
      >
        <header id="modalTitle" class="modal-header">
          <!-- Window top part -->
          <slot name="header">
            <span class="modal-title">{{ title }}</span>
            <div v-if="canClose === true">
              <button
                type="button"
                class="btn-close"
                aria-label="Close modal"
                @click="close"
              >
                <close-box title="Close" />
              </button>
            </div>
          </slot>
        </header>
        <section id="modalDescription" class="modal-body">
          <!-- Window center part -->
          <slot name="body"></slot>
        </section>
        <footer class="modal-footer">
          <!-- Window bottom part -->
          <slot name="footer">
            <button
              v-if="showOk"
              type="button"
              class="btn-ok"
              aria-label="Close modal"
              @click="submit"
            >
              OK
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--modal-backdrop-z);
  overflow-y: auto;
}

.modal {
  background: #233d4e;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  z-index: var(--modal-z);
  border-radius: 4px;
  padding: 10px;
}

.modal-title {
  width: 100%;
  text-align: center;
  margin: 5px;

  /** font */
  font-size: 1.2rem;
  color: white;
  font-weight: bold;
}
.modal-header,
.modal-footer {
  display: flex;
}

.modal-header {
  padding-top: 10px;
  border-bottom: 1px transparent var(--grey);
  color: var(--grey);
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px transparent var(--grey);
  justify-content: center;
  padding: 10px;
}

.modal-body {
  position: relative;
  padding: 10px 10px;
}

.btn-close {
  border: none;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  color: var(--grey);
  background: transparent;
}

.btn-close:hover path {
  color: #ed5229;
}

.btn-ok {
  color: white;
  background: var(--grey);
  border: 1px solid #ffffff;
  border-radius: 5px;
  width: 3rem;
  padding: 0.25em 0.5em;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .modal {
    position: absolute;
    top: 50px;
  }
}
</style>
